import GenericRequest, { METHOD_POST } from '../../../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../../../shared/webservices/endpoint';

export class ContractorSearchTask extends GenericRequest {

    _request; // ContractorSearchRequest

    constructor(request) {
        super(METHOD_POST, ApiEndpoints.CONTRACTORS_RELATED);
        this._request = request;
    }

    overrideRequest() {
        return this._request.body();
    }

}



// WEBPACK FOOTER //
// ./src/app/my-contractors/contractor/list/contractor-search/ContractorSearchTask.js